var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Index"}},[_c('div',{staticClass:"out-bj"},[_c('keep-alive',[_c('router-view',{attrs:{"id":""}})],1)],1),_c('public-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }